import ServiceCard from "@/components/ServiceCard";
import SectionHeading from "@/components/SectionHeading";
import { SERVICES } from "@/lib/data";

export default function Leistungen() {
  return (
    <div data-testid="leistungen-page">
      <section className="relative pt-40 pb-20 lg:pt-48 lg:pb-28 bg-messinger-bg overflow-hidden border-b border-white/5">
        <div className="absolute inset-x-0 top-0 h-[60%] bg-gradient-to-b from-messinger-orange/10 to-transparent pointer-events-none" />
        <div className="container-x relative">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-messinger-orange" />
            <span className="text-[11px] tracking-[0.28em] uppercase font-semibold text-messinger-orange">
              Leistungen
            </span>
          </div>
          <h1 className="font-heading font-semibold text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-3xl text-balance">
            Sechs Kompetenzen. <br />
            <span className="text-messinger-orange">Ein Ansprechpartner.</span>
          </h1>
          <p className="mt-6 text-white/65 text-lg max-w-2xl">
            Vom Schadengutachten nach dem Unfall bis zur Oldtimerbewertung —
            jede Leistung führe ich persönlich durch. Wählen Sie eine Leistung
            für Details, Ablauf und direkte Terminanfrage.
          </p>
        </div>
      </section>

      <section className="bg-messinger-surface py-24 lg:py-28 relative overflow-hidden">
        <div className="container-x relative">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {SERVICES.map((s, i) => (
              <ServiceCard key={s.slug} service={s} index={i} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
